import { useEffect } from 'react';

/**
 * Simple hook for capturing a keypress on document.
 *
 * @param {string} [key] Key.
 * @param {Function} [onPress] OnPress.
 */
const useKeyPress = (
  key: string,
  onPress?: (e: KeyboardEvent) => void,
): void => {
  const handleKeydown = (e: KeyboardEvent): void => {
    if (e?.key?.toLowerCase() === key?.toLowerCase()) {
      onPress?.(e);
    }
  };

  useEffect(() => {
    document.addEventListener('keydown', handleKeydown);

    return (): void => {
      document.removeEventListener('keydown', handleKeydown);
    };
    // eslint-disable-next-line
  }, [key, onPress]);
};

export default useKeyPress;
